<template>
  <div class="header">
    <div class="row">
      <div class="column" style="display: flex;">
        <div class="logo">
          <img class="logoimg" src="https://designnavigator.daimler.com/img/template/mb/MB-star_n_web.svg"
               onerror="this.style.display='none';" alt="">
        </div>
        <div class="logo-name">
          <img class="logoNameimg" src="https://designnavigator.daimler.com/img/template/mb/brand-without-claim.svg"
               onerror="this.style.display='none';" alt="">
        </div>
      </div>
      <div class="policy div2" style="overflow: hidden;">
        <wb-select label="Model selection" compact style="float: left; padding-top:25px;" theme="dark">
          <select v-model="selectedLocalefromUrl" @change="changeLang()" id="locale" >
            <option value="en" >English</option>
            <option value="ara">عربـي</option>
            <option value="bg">Български</option>
            <option value="chs">简体中文</option>
            <option value="cht">繁體中文</option>
            <option value="csy">Čeština</option>
            <option value="da">Dansk</option>
            <option value="de">Deutsch</option>
            <option value="es">Español</option>
            <option value="fr">Français</option>
            <option value="fi">Suomi</option>
            <option value="heb">עברית</option>
            <option value="hu">Magyar</option>
            <option value="it">Italiano</option>
            <option value="ind">Indonesian</option>
            <option value="ja">日本の</option>
            <option value="ko">한국어</option>
            <option value="msl">Melayu</option>
            <option value="nl">Nederlands</option>
            <option value="no">Norsk</option>
            <option value="pl">Polski</option>
            <option value="pt">Português</option>
            <option value="ro">Română</option>
            <option value="ru">Русский</option>
            <option value="sk">Slovenčina</option>
            <option value="sv">svensk</option>
            <option value="tr">Türkce</option>
            <option value="ukr">український</option>
            <option value="srl">Hrvatski</option>
          </select>
        </wb-select>
        <!-- <div  class="localebackground" >
        </div> -->
        <!-- <div style="margin-left: 1rem;display:inline;">
            <svg class="policyimagesvg">
                <image class="policyimage"
                    xlink:href="https://designnavigator.daimler.com/img/template/svg/infoMB.svg" />
            </svg>
            <span><a :href="setupLink" target="_blank" style="color:white;text-decoration:none;">{{ t('privacy')
            }}</a> </span>
        </div> -->
      </div>
    </div>
  </div>

</template>

<script>
import {useI18n} from "vue-i18n";

export default {
  name: "HeaderView",
  setup() {
    const { t, locale } = useI18n();
    return {
      t, locale
    };
  },
  watch: {
    '$route': {
      handler() {
        const locale = this.$route.query.locale;
        function trimlocale(locale) {
          return locale.split('-')[0];

        }
        if (locale) {
          this.selectedLocalefromUrl = trimlocale(locale)
        }
      },
      deep: true
    }
  },
  methods: {
    changeLang() {
      let el = document.getElementById("locale");
      this.locale = this.otherLanguage(el.value)
    },
    otherLanguage(locale) {
      for (let i = 0; i < this.allLocales.length; i++) {
        if (this.allLocales[i].symbol == locale) {
          locale = this.allLocales[i].symbol
          return locale
        }
      }
    },
  },
  data() {
    return {
      selectedLocalefromUrl: {},
      lang: 'en',
      setupLink: "https://dcp-media-connect-prod.mercedes-benz.com/dcpmedia/In-Car-Office-Setup-Guide-1.3-B2C-EN.pdf?context=bWFzdGVyfGluc3RydWN0aW9uc3wzNjgwNDI2fGFwcGxpY2F0aW9uL3BkZnxpbnN0cnVjdGlvbnMvaGU1L2gwOC82ODAxNzczMDg0Njc1MC5wZGZ8OGVjMDgyYWUxOTc5MzQ2OTJlNGFiZmE4ODEwMjVkYTRlYzllYTZkZjYzOWVmNDA2NTZjMzRiYjgzZmFmNzk2OA",
      allLocales: [
        {
          symbol: "en",
          name: "English"
        },
        {
          symbol: "de",
          name: "Deutsch"
        },
        {
          symbol: 'fr',
          name: "français"
        },
        {
          symbol: 'bg',
          name: "български"
        },
        {
          symbol: 'chs',
          name: "简体中文"
        },
        {
          symbol: 'cht',
          name: "繁体中文"
        },
        {
          symbol: 'csy',
          name: "Čeština",
        },
        {
          symbol: 'ara',
          name:"عربـي"
        },
        {
          symbol: 'da',
          name: "Dansk"
        },
        {
          symbol: 'es',
          name: "Español"
        },
        {
          symbol: 'fi',
          name: "Suomi"
        },
        {
          symbol: 'heb',
          name: "עברית"
        },
        {
          symbol: 'hu',
          name: "magyar"
        },
        {
          symbol: 'it',
          name: "italiano"
        },
        {
          symbol: 'ind',
          name: "indonesian"
        },
        {
          symbol: 'ko',
          name: "한국어"
        },
        {
          symbol: 'nl',
          name: "Nederlands"
        },
        {
          symbol: 'no',
          name: "norsk"
        },
        {
          symbol: 'pl',
          name: "polski"
        },
        {
          symbol: 'pt',
          name: "Português"
        },
        {
          symbol: 'ro',
          name: "Română"
        },
        {
          symbol: 'ru',
          name: "Русский"
        },
        {
          symbol: 'sk',
          name: "Slovenčina"
        },
        {
          symbol: 'srl',
          name: "Hrvatski"
        },
        {
          symbol: 'sv',
          name: "Svenska"
        },
        {
          symbol: 'tr',
          name: "Türkçe"
        },
        {
          symbol: 'ukr',
          name: "Українська"
        },
        {
          symbol: 'msl',
          name: "Melayu"
        },
        {
          symbol: 'ja',
          name: "日本の"
        }

      ],
    }
  },
}
</script>

<style scoped>
.header {
  z-index: 99999 !important;
}
.localebackground {
  background-image: url("https://designnavigator.daimler.com/img/template/svg/languageMB.svg");
  background-repeat: no-repeat;
  background-position: center center;
  font-size: 10px;
  top: 15px;
  right: 38px;
  width: 4rem;
  line-height: 25px;
  height: 2rem;
  padding-left: 0.5rem;
  padding-top: 0.1rem;
  padding-right: 1rem;
  cursor: pointer;
}

.policy {
  position: fixed;
  right: 1rem;
  font-size: 15px;
  color: white;
}

.policyimagesvg {
  width: 15px;
  height: 15px;
  vertical-align: middle;
}

.policyimage {
  width: 15px;
  height: 15px;
}

.logoimg {
  width: 10rem;
  position: fixed;
  left: 2rem;
  top: 1rem;
  height: 65px;
}
.logoNameimg {
  width: 10rem;
  position: fixed;
  left: 10rem;
  top: 2.5rem;
  height: 30px;
}
.header {
  background-color: #000;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  visibility: visible;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 6rem;
}

#div1 {
  text-align: left;
}

.div1 {
  float: left;
  font-size: 2rem;
}

.div2 {
  float: right;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .logoNameimg {
    display: none;
  }
  .logoimg {
    left: -2rem;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .logoNameimg {
    display: none;
  }
  .logoimg {
    left: -2rem;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .logoNameimg {
    display: block;
  }
  .logoimg {
    left: 2rem;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .logoNameimg {
    display: block;
  }
  .logoimg {
    left: 2rem;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .logoNameimg {
    display: block;
  }
  .logoimg {
    left: 2rem;
  }
}
</style>